module.exports = __webpack_public_path__ + "static/img/2-5.280b2c73.png";